import {httpGet} from "../util";

const SEARCH_ENDPOINT = "/webapi/search/authors/{text}";

const SearchApi = {
  async search(text) {
    const url = SEARCH_ENDPOINT.replace('{text}', text);
    return await httpGet(url, ({ authors }) => authors);
  }
};

export default SearchApi;